<template>
  <div class="discussion-message">
    <b-card :header="formatDateTime(date)" class="notif-card">

    <slot></slot>
  </b-card>
  </div>
</template>

<script>
import formatter from '@/components/global/mixins/formatterMethods'

export default {
  mixins: [formatter],

  props: {
    date: {
      type: [Date, String],
      required: true
    }
  }
}
</script>
